<template>
    <section class="section hero">
        <div class="container">
            <div class="row">
                <div class="col s12">
                    <h2 class="header">{{header}}</h2>
                    <p class="caption">
                        {{caption}}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            header: {
                type: String,
                required: false
            },
            caption: {
                type: String
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/common/HeaderSection.vue